import styled, { css } from 'styled-components';
import cores from '../../styles/cores';

export const InputsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 0px;
  padding: 0;
  margin: 10px 10px;
  max-width: 100%;
  .input {
    width: 250px;
  }

  .visually-hidden {
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
    opacity: 0;
  }

  &.descricao-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0 !important;

    h2 {
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.upload-fotos {
    border: 0px solid black;
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 0;
    margin-top: 0;
    p:first-child {
      margin-top: 10px;
      font-style: italic;
      font-size: 14px;
    }
  }
`;

export const SessionContente = styled.div`

  display: flex;
  border: 0px solid black;
  flex-wrap: wrap;
  max-width: 100%;
  width: 100%;
  font-color: gray;

  border: 0px solid black;
  margin-top: 20px;
  align-items: center;
  h2 {
    margin-right: 10px;
    font-weight: bold;
  }

padding: 0;


`;